import { loading, retrievedUser } from 'store/actions/auth.actions';
import HttpClient from 'services/http/HttpClient';
import { putDatabase } from 'store/actions/database.actions';
import { normalize } from 'normalizr';
import { get } from 'lodash';
import { CONSTANTS } from 'services/constants';
import { authUserSchema, memberSchema } from 'store/schemas/database.schemas';
import { loadMe } from 'store/dispatchers/members.dispatchers';
import { buildAuthLoadingSelector } from 'store/selectors/auth.selector';

const httpClient = new HttpClient();

export function checkAuth()
{
    return async (dispatch, getState) =>
    {
        const loadingBuilder = buildAuthLoadingSelector();
        const isLoading = loadingBuilder(getState());

        if (isLoading) return;

        dispatch(loading(true));

        const response = await httpClient.request('GET', `/v1${CONSTANTS.AUTH.FETCH_USER_ENDPOINT}`, null);

        if (get(response, 'response.id'))
        {
            const user = response.response;
            user.member = await dispatch(loadMe());
            if (user.member === null)
            {
                return;
            }
            const result = normalize(user, authUserSchema);

            dispatch(retrievedUser(user));
            dispatch(putDatabase(result.entities));

            const memberResult = normalize(user.member, memberSchema);
            dispatch(putDatabase(memberResult.entities));

            dispatch(loading(false));
            return;
        }

        dispatch(loading(false));
    };
}
